import React from "react";
import { carsStatuses } from "./../../../components/sections/cars/static.carsStatuses";
import styles from "./carStatusTitle.module.scss";

const getStatusById = function (id) {
  switch (parseInt(id)) {
    case carsStatuses.inmotion.id:
      return carsStatuses.inmotion;

    case carsStatuses.parking.id:
      return carsStatuses.parking;

    case carsStatuses.fueling.id:
      return carsStatuses.fueling;

    case carsStatuses.drain.id:
      return carsStatuses.drain;

    default:
      return carsStatuses.loss;
  }
};

const getStyles = (id) => {
  switch (parseInt(id)) {
    case carsStatuses.inmotion.id:
      return styles.carStatusTitle_inMove;

    case carsStatuses.parking.id:
      return styles.carStatusTitle_parking;

    case carsStatuses.fueling.id:
      return styles.carStatusTitle_fuiling;

    case carsStatuses.drain.id:
      return styles.carStatusTitle_drain;

    default:
      return styles.carStatusTitle_noData;
  }
};

const CarStatusTitle = (props) => {
  const status = getStatusById(props.status);

  return <span className={getStyles(props.status)}> {status.title}</span>;
};

export default React.memo(CarStatusTitle);
